import { z } from "zod";

export const productionGrainCreationSchema = z.object({
  nombre: z.string().trim().min(1, "El nombre es obligatorio."),
  aplicaPPMB: z.any().refine(
    (value) => {
      const selected = Array.isArray(value) ? value[0] : value;
      return selected === true || selected === false || selected === "true" || selected === "false";
    },
    { message: "Debe seleccionar si aplica PP y MB." },
  ),
  granoAdmis: z
    .string()
    .trim()
    .min(1, "El código ADMIS es obligatorio.")
    .refine((value) => !Number.isNaN(Number(value)), {
      message: "El código ADMIS debe ser numérico.",
    }),
  sumaHA: z.any().refine(
    (value) => {
      const selected = Array.isArray(value) ? value[0] : value;
      return selected === true || selected === false || selected === "true" || selected === "false";
    },
    { message: "Debe seleccionar si suma HA." },
  ),
});

export type ProductionGrainCreationForm = z.infer<
  typeof productionGrainCreationSchema
>;
